import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-ww-wallet',
  templateUrl: './ww-wallet.component.html',
  styleUrls: ['./ww-wallet.component.scss']
})
export class WwWalletComponent implements AfterViewInit {
  public company_uuid;

  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService, private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
   }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/wallet/history', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Description', type: 'string', key: 'description'}, 
          {label: 'Debit', type: 'number', key: 'debit'}, 
          {label: 'Credit', type: 'number', key: 'credit'}, 
          {label: 'Balance', type: 'number', key: 'balance'},
          {label: 'Create On', type: 'timestamp', key: 'create_on'},
        ]}
    this.tb.init(setting);
    this.cdr.detectChanges();
  }

}
